/**
 * Interface for account and monthly data storage services
 * Implementations: LocalStorageAccountService, FirebaseAccountService
 */
export class IAccountStorageService {
  /**
   * Load all account data (accounts and monthly entries)
   * @returns {Promise<import('../models/AccountModels').AccountData>}
   */
  async loadData() {
    throw new Error('Method not implemented');
  }

  /**
   * Save accounts data
   * @param {import('../models/AccountModels').Accounts} accounts
   * @returns {Promise<void>}
   */
  async saveAccounts(accounts) {
    throw new Error('Method not implemented');
  }

  /**
   * Save monthly data
   * @param {import('../models/AccountModels').MonthlyEntry[]} monthlyData
   * @returns {Promise<void>}
   */
  async saveMonthlyData(monthlyData) {
    throw new Error('Method not implemented');
  }

  /**
   * Add a new account
   * @param {import('../models/AccountModels').Account} account
   * @returns {Promise<import('../models/AccountModels').Account>}
   */
  async addAccount(account) {
    throw new Error('Method not implemented');
  }

  /**
   * Remove an account
   * @param {string} accountName
   * @param {string} type - 'asset' or 'debt'
   * @returns {Promise<void>}
   */
  async removeAccount(accountName, type) {
    throw new Error('Method not implemented');
  }

  /**
   * Save a monthly entry
   * @param {import('../models/AccountModels').MonthlyEntry} entry
   * @returns {Promise<void>}
   */
  async saveMonthlyEntry(entry) {
    throw new Error('Method not implemented');
  }

  /**
   * Clear all data
   * @returns {Promise<void>}
   */
  async clearAll() {
    throw new Error('Method not implemented');
  }
}
